// extracted by mini-css-extract-plugin
export var anchor = "styles-module__anchor___OaLM_";